import { CONTRACT_BASE_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import {
  ICitiesResponse,
  INationalAddressLookupResponse,
  IProvincesResponse,
} from "./models";

const defaultProvide = async () => await getToken();

/**
 * Looks up a short national address (e.g. RRRD1234) on the shipping service — the same lookup
 * the web app uses for shipping addresses. Rejects when the code isn't found.
 */
export const lookupNationalAddress = (
  nationalAddress: string
): Promise<INationalAddressLookupResponse> => {
  const url = `${CONTRACT_BASE_URL}shipping/api/national-address?nationalAddress=${encodeURIComponent(
    nationalAddress
  )}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const getProvinces = (): Promise<IProvincesResponse> => {
  const url = `${CONTRACT_BASE_URL}shipping/api/province/all`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const getCitiesByProvince = (
  provinceId: number
): Promise<ICitiesResponse> => {
  const url = `${CONTRACT_BASE_URL}shipping/api/city/all?provinceId=${provinceId}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

/** Districts come back in the same shape as cities. */
export const getDistrictsByCity = (
  cityId: number
): Promise<ICitiesResponse> => {
  const url = `${CONTRACT_BASE_URL}shipping/api/city/districts/${cityId}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};
